const DEPORTE_ALIASES = {
  futbol: 'futbol',
  fútbol: 'futbol',
  football: 'futbol',
  soccer: 'futbol',
  futsal: 'futbol',
  'futbol sala': 'futbol',
  'fútbol sala': 'futbol',
  basquetbol: 'basquetbol',
  básquetbol: 'basquetbol',
  baloncesto: 'basquetbol',
  basketball: 'basquetbol',
  voleibol: 'voleibol',
  volleyball: 'voleibol',
  natacion: 'natacion',
  natación: 'natacion',
  swimming: 'natacion',
  gimnasia: 'gimnasia',
  gymnastics: 'gimnasia',
  tenis: 'tenis',
  tennis: 'tenis',
  artes_marciales: 'artes_marciales',
  'artes marciales': 'artes_marciales',
  karate: 'artes_marciales',
  judo: 'artes_marciales',
  taekwondo: 'artes_marciales',
  atletismo: 'atletismo',
  athletics: 'atletismo',
  waterpolo: 'waterpolo',
  'water polo': 'waterpolo',
  'water-polo': 'waterpolo',
  general: 'general',
  otro: 'general',
  other: 'general',
};

function stripAccents(value) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function normalizeDeporteSlug(value) {
  if (!value || !String(value).trim()) {
    return 'general';
  }
  const raw = String(value).trim().toLowerCase();
  const rawNoAccents = stripAccents(raw);
  if (DEPORTE_ALIASES[rawNoAccents]) {
    return DEPORTE_ALIASES[rawNoAccents];
  }
  if (DEPORTE_ALIASES[raw]) {
    return DEPORTE_ALIASES[raw];
  }
  const slug = rawNoAccents.replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  if (slug.startsWith('futbol')) {
    return 'futbol';
  }
  return slug || 'general';
}

/** Fútbol, Fútbol 7/11, futsal, soccer, etc. */
export function isFutbolSport(value) {
  const slug = normalizeDeporteSlug(value);
  return slug === 'futbol';
}
